import { render, staticRenderFns } from "./ApprovalFileInput.vue?vue&type=template&id=b60758c2&scoped=true"
import script from "./ApprovalFileInput.vue?vue&type=script&lang=js"
export * from "./ApprovalFileInput.vue?vue&type=script&lang=js"
import style0 from "./ApprovalFileInput.vue?vue&type=style&index=0&id=b60758c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60758c2",
  null
  
)

export default component.exports